import { createContext } from 'react';

import {
  FilterField,
  FilterOption,
  InputData,
} from '@totem/components/ui_components/reportSettings/types';
import { Filter, Params } from '@totem/types/common';

const emptyParams: Params = {
  paging: {
    page: 1,
    pageSize: 10,
  },
  sort: {
    field: '',
    direction: 1,
  },
  filters: [],
};

interface Context {
  input: InputData;
  handleSort: (field: string, direction: string) => void;
  handlePagination: (page: number, pageSize: number) => void;
  handleFilter: (filterKey: string, filterValues: string[] | string) => void;
  handleTableChange: (
    pagination: any,
    filters: any,
    sorter: any,
    extra: any,
  ) => void;
  buildParameters: () => Params;
  staticFilters: Filter[];
  setStaticFilters: (filters: Filter[]) => void;
  setFilterOptions: (key: string, options: FilterOption[]) => void;
  getFilterField: (key: string) => FilterField;
  getFilterOptions: (key: string) => FilterOption[];
  getFilterValues: (key: string) => string[];
  getFilterValue: (key: string) => string;
  updateCount: number;
  filterUpdateCount: number;
  pagingUpdateCount: number;
  sortingUpdateCount: number;
  isReady: boolean;
}

const InputContext = createContext<Context>({
  input: {
    pagination: {
      page: 1,
      pageSize: 10,
    },
    sort: {
      field: '',
      direction: '',
    },
    filters: [],
  },
  handleSort: () => {},
  handlePagination: () => {},
  handleFilter: () => {},
  handleTableChange: () => {},
  buildParameters: () => emptyParams,
  staticFilters: [],
  setStaticFilters: () => {},
  getFilterField: () => null,
  setFilterOptions: () => {},
  getFilterOptions: () => [],
  getFilterValues: () => [],
  getFilterValue: () => '',
  updateCount: 0,
  filterUpdateCount: 0,
  pagingUpdateCount: 0,
  sortingUpdateCount: 0,
  isReady: false,
});

export default InputContext;
